import React from "react";
import { useParams, useOutletContext } from "react-router-dom";
import { UsersPanel } from "../components/users-panel.jsx";
import type { AdminOutletContext } from "../lib/outlet-context";

export function ClientUsersPage() {
  const { clientId } = useParams();
  const { clients, updateClient, api } = useOutletContext<AdminOutletContext>();
  const client = clients.find((c) => c.id === clientId);

  if (!client) {
    return (
      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed py-16 text-center">
        <p className="text-sm text-muted-foreground">Client not found</p>
        <p className="mt-1 text-xs text-muted-foreground">It may still be loading — try refreshing.</p>
      </div>
    );
  }

  return (
    <UsersPanel
      client={client}
      api={api}
      onUsersChanged={(count: number) => {
        if (count !== client.user_count) updateClient({ ...client, user_count: count });
      }}
    />
  );
}
